'use es6';

import { createAction } from 'redux-actions';
import { GENERIC_CHANNEL_ID_CHANGED } from '../constants/actionTypes';
export const genericChannelIdChanged = createAction(GENERIC_CHANNEL_ID_CHANGED, ({
  channelId
}) => ({
  channelId
}));